// ABOUTME: Picks the PIM language ISO code the catalog filters should be worded in, from the browser locale.
// ABOUTME: First tenant language matching the locale (e.g. "it" -> "it-IT"), otherwise the tenant default.

export function resolveCatalogLanguage(
    locale: string,
    isoCodes: string[],
    defaultLanguage: string,
): string {
    const wanted = locale.trim().toLowerCase();
    if (!wanted) {
        return defaultLanguage;
    }
    const exact = isoCodes.find(code => code.toLowerCase() === wanted);
    if (exact) {
        return exact;
    }
    const base = wanted.split('-')[0];
    return isoCodes.find(code => code.toLowerCase().split('-')[0] === base) ?? defaultLanguage;
}
